"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_LOGS_SERVICE = exports.DOWNLOAD_MODEL_SERVICE = exports.RESTART_SERVICE = exports.SESSION_SERVICE = exports.STATUS_SERVICE = void 0;
exports.STATUS_SERVICE = '/ServerBuddy/status';
exports.SESSION_SERVICE = '/ServerBuddy/session';
exports.RESTART_SERVICE = '/ServerBuddy/restartService';
exports.DOWNLOAD_MODEL_SERVICE = '/ServerBuddy/downloadModel';
exports.GET_LOGS_SERVICE = '/ServerBuddy/getLogs';
